export default __webpack_public_path__ + "static/media/a-domicilio.ae66310e.png";